import React from 'react';
import { withRouter } from 'react-router-dom'
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import {
    Divider
} from '@material-ui/core';

import routes from 'mdoc/admin/routes/config';
import SiderMenu from 'mdoc/admin/components/SiderMenu';
import {ByteFormatToGB} from 'mdoc/utils';
import logo from 'mdoc/style/imgs/logo.png';
import 'mdoc/admin/components/sider.less';
import * as config from 'mdoc/admin/axios/config';
import { getUserInfo } from 'mdoc/admin/axios';

const styles = theme => ({
    root: {
        width: '100%',
        maxWidth: 360,
        backgroundColor: theme.palette.background.paper,
    },
    overview:{
    },
    overviewTitle:{
        marginLeft: 20,
        marginRight: 10,
        color:theme.palette.primary.main,
        fontWeight: true
    },
    logo:{
        width: 200,
        cursor:'pointer',
        margin:'10px'
    }
});

class SiderCustom extends React.Component {
    static setMenuOpen = props => {
        const {pathname} = props.location
        return {
            openKey: pathname.substr(0, pathname.lastIndexOf('/')),
            selectedKey: pathname.indexOf('_') >= 0 ? pathname.substr(0, pathname.indexOf('_')) : pathname,
        }
    }
    state = {
        collapsed: false,
        mode: 'inline',
        openKey: '',
        selectedKey: '',
        firstHide: false, // 点击收缩菜单，第一次隐藏展开子菜单，openMenu时恢复
        permissions: [],
    }

    componentWillMount () {
        const state = SiderCustom.setMenuOpen(this.props);
        this.setState(state);
    }
    componentWillReceiveProps() {
        const state = SiderCustom.setMenuOpen(this.props);
        this.setState(state);
    }

    handleClickLogo(){
        let user = getUserInfo();
        window.localStorage.setItem(user.clientId + '/loading',true);
        this.props.history.push('/');
    }
    render() {
        const {classes,dictWord,clientsInfo,auth} = this.props;
        console.log(this.state)
        return (
            <div className={classes.root}>
                <div className={classes.toolbar}>
                    <img src={logo} alt="logo" onClick={this.handleClickLogo.bind(this)} className={classes.logo} />
                </div>
                <Divider />
                {clientsInfo?<div>
                    {auth.data.roleId && auth.data.roleId===9?<div className={classes.overview}>
                        <p><span className={classes.overviewTitle}>{dictWord.registered_clients_count}</span>{clientsInfo.registeredClientsCount} <font style={{fontSize:'10px'}}>{dictWord.group}</font></p>
                        <p><span className={classes.overviewTitle}>{dictWord.runing_clients_count}</span>{clientsInfo.runingClientsCount} <font style={{fontSize:'10px'}}>{dictWord.group}</font></p>
                        <p><span className={classes.overviewTitle}>{dictWord.created_user_count}</span>{clientsInfo.createdUserCount} <font style={{fontSize:'10px'}}>{dictWord.user}</font></p>
                        <p><span className={classes.overviewTitle}>{dictWord.book_count}</span>{clientsInfo.bookCount} <font style={{fontSize:'10px'}}>{dictWord.content}</font></p>
                    </div>:<div className={classes.overview}>
                        <p><span className={classes.overviewTitle}>{dictWord.available_capacity}</span>{ByteFormatToGB(clientsInfo.diskSize)}GB/{ByteFormatToGB(clientsInfo.capacity)}GB</p>
                        <p><span className={classes.overviewTitle}>{dictWord.content_count}</span>{clientsInfo.bookCount}</p>
                        <p><span className={classes.overviewTitle}>{dictWord.service_start_date}</span>{clientsInfo.startTimeStr}</p>
                        <p><span className={classes.overviewTitle}>{dictWord.service_end_date}</span>{clientsInfo.endTimeStr}</p>
                        <p><span className={classes.overviewTitle}>{dictWord.user_count}</span>{clientsInfo.createdUserCount+'/'+clientsInfo.userCreateNum}</p>
                    </div>}
                    <Divider /></div>:null}

                <SiderMenu
                    menus={routes.menus}
                    commondict={dictWord}
                    openkey={this.state.openKey}
                    selectedkey={this.state.selectedKey}
                />
            </div>
        );
    }
}

SiderCustom.propTypes = {
    classes: PropTypes.object.isRequired,
    dictWord:PropTypes.object.isRequired,
};

export default withStyles(styles)(withRouter(SiderCustom));